import { DEFAULT_ACTION,FORMDATA, SETFORMDATA, SETVALUEFETCH } from "./constants";

export function defaultAction() {
  return {
    type: DEFAULT_ACTION
  };
}

export function formData(data) {
  return {
    type: FORMDATA,
    payload: data
  }
}

export function setFormValue(data){
  return {
    type: SETFORMDATA,
    payload: data
  }
}

export function setvalueFetch(valuefetched){
  return {
    type: SETVALUEFETCH,
    payload: valuefetched
  }
}